import { render, staticRenderFns } from "./CancellationForm.vue?vue&type=template&id=5033ace4&scoped=true&"
import script from "./CancellationForm.vue?vue&type=script&lang=ts&"
export * from "./CancellationForm.vue?vue&type=script&lang=ts&"
import style0 from "./CancellationForm.vue?vue&type=style&index=0&id=5033ace4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5033ace4",
  null
  
)

export default component.exports